<template>
  <div>
    <TheCreateUserModal
      :show="isShow[modalTypes.CreateUserModal]"
      @close="closeModal"
    />
    <TheEditAuctionModal
      :show="isShow[modalTypes.EditAuctionModal]"
      @close="closeModal"
    />
    <TheViewTeslaAuctionModal
      :show="isShow[modalTypes.ViewTeslaVehicle]"
      @close="closeModal"
    />
    <TheEditMarketplaceModal
      :show="isShow[modalTypes.EditMarketplaceModal]"
      @close="closeModal"
    />
    <TheDefaultModal
      :show="isShow[modalTypes.DefaultModal]"
      @close="closeModal"
    />
    <TheConfirmationModal 
      :show="isShowConfirmationModal"
      @close="closeConfirmationModal"
    />
    <TheCommentModal
      :show="isShow[modalTypes.CommentModal]"
      @close="closeModal"
    />
    <TheEditCarModal
      :show="isShow[modalTypes.EditCarModal]"
      @close="closeModal"
    />
    <TheDeclineCarModal
      :show="isShow[modalTypes.DeclineCarModal]"
      @close="closeModal"
    />
    <TheChangePasswordModal
      :show="isShow[modalTypes.ChangePasswordModal]"
      @close="closeModal"
    />
    <TheBlogModal
      :show="isShow[modalTypes.BlogModal]"
      @close="closeModal"
    />
    <TheSeoModal
      :show="isShow[modalTypes.SeoModal]"
      @close="closeModal"
    />
    <TheVdpModal
      :show="isShow[modalTypes.VdpModal]"
      @close="closeModal"
    />
    <TheAuctionBannerModal
      :show="isShow[modalTypes.AuctionBannerModal]"
      @close="closeModal"
    />
    <TheForgotPasswordModal
      :show="isShow[modalTypes.ForgotPasswordModal]"
      @close="closeModal"
    />
    <TheCommentsModal :show="isShow[modalTypes.CommentsModal]"
      @close="closeModal"/>
  </div>
</template>

<script>
import ModalType from "@/utils/dictionaries/modalType";
import TheCreateUserModal from "./TheCreateUserModal";
import TheEditAuctionModal from "./TheEditAuctionModal";
import TheEditMarketplaceModal from "./TheEditMarketplaceModal";
import TheDefaultModal from "./TheDefaultModal";
import TheConfirmationModal from "./TheConfirmationModal";
import TheCommentModal from './TheCommentModal';
import TheEditCarModal from './TheEditCarModal';
import TheDeclineCarModal from './TheDeclineCarModal';
import TheChangePasswordModal from './TheChangePasswordModal';
import TheBlogModal from './TheBlogModal';
import TheSeoModal from './TheSeoModal';
import TheVdpModal from './TheVdpModal';
import TheAuctionBannerModal from './TheAuctionBannerModal';
import { createModalMixin, modalStore } from "@/mixins/modalsMixin";
import TheForgotPasswordModal from "./TheForgotPasswordModal.vue";
import TheCommentsModal from "./TheCommentsModal.vue";
import TheViewTeslaAuctionModal from "./TheViewTeslaAuctionModal";

export default {
  name: "TheModals",

  mixins: [createModalMixin()],

  components: {
    TheCreateUserModal,
    TheEditAuctionModal,
    TheDefaultModal,
    TheConfirmationModal,
    TheCommentModal,
    TheEditMarketplaceModal,
    TheEditCarModal,
    TheDeclineCarModal,
    TheChangePasswordModal,
    TheBlogModal,
    TheSeoModal,
    TheVdpModal,
    TheAuctionBannerModal,
    TheForgotPasswordModal,
    TheCommentsModal,
    TheViewTeslaAuctionModal
},
  
  computed: {
    modalTypes() {
      return ModalType;
    },
    activeModal() {
      return this[modalStore.getterTypes.GETTER_OPENED_MODAL];
    },
    isModalsOpen() {
      return this[modalStore.getterTypes.GETTER_OPENED_MODAL].length;
    },
    isShow() {
      return Object.keys(ModalType).reduce((acc, modalType) => {
        acc[modalType] = modalType === this.activeModal;
        return acc;
      }, {});
    },
    isShowConfirmationModal() {
      return this[modalStore.getterTypes.GETTER_OPENED_CONFIRMATION_MODAL];
    }
  },

  methods: {
    closeModal() {
      this.$modals.close();
    },
    closeConfirmationModal() {
      this.$modals.close(ModalType.ConfirmationModal)
    }
  }
};
</script>
